import { Component, OnInit } from '@angular/core';

import { ApifirstService } from 'src/app/service/apifirst.service';

@Component({
  selector: 'app-targetting-engine-test',
  templateUrl: './targetting-engine-test.component.html',
  styleUrls: ['./targetting-engine-test.component.scss']
})
export class TargettingEngineTestComponent implements OnInit {
  public type = '';
  public id = '';
  public uid = '';
  public showSuggest = false;
  public componentPost: any;
  public componentId = '';
  public language = '';
  public country = '';
  public symptomList = '';
  public vehicleModel = '';
  public invinnumber: any;
  public res: any;
  public submitRes: any;
  public getApiRes: any;
  public isShow = false;
  public userId: any;
  public username: any;
  public userType: any;
  public TEPostRepairDetails: any = [];
  public TEDescDetails: any = [];
  public iserr = false;
  constructor(private service: ApifirstService) {
    this.service.userId.subscribe((data) => {
      this.userId = data
    })

    this.service.tokenObj.subscribe((data) => {
      this.res = data;
      this.country = this.res.countryThree;
      this.language = this.res.language;
      this.invinnumber = this.res.vin
      this.username = this.res.username
      this.userType = this.res.userType
    })

    this.service.getTargetEngineTestDetailsApi(this.invinnumber, this.country, this.language).subscribe((data) => {
      this.getApiRes = data;
      this.vehicleModel = this.getApiRes.vehicleModelXml;
    })
  }

  ngOnInit(): void {
    let sessionId = localStorage.getItem("sessionID");
    this.service.getTEPostRepairDetails(this.invinnumber, this.country, this.language, this.userId, this.username, this.userType, sessionId ).subscribe((data) => {
      this.TEPostRepairDetails = data
      for (let i of this.TEPostRepairDetails) {
        this.TEDescDetails.push(i.description)
      }
    })
  }
  /** to get the vehicle name when searched by VIN number**/
  vindetailsApi() {

    const req =
    {
      "requestType": this.type,
      "languageCode": this.language,
      "countryCode": this.country,
      "symptoms": this.symptomList,
      "vehicleModel": this.invinnumber,
      "username": this.username
    }
    if (this.type && this.language && this.country && this.symptomList && this.invinnumber) {
      this.service.insertTargetEngineTestDetails(req).subscribe(
        (data) => {
          this.submitRes = data;
          this.isShow = true;
          this.iserr = false;
          if (this.submitRes.response == "candidates not found") {
            this.isShow = false;
            this.iserr = true;
          }
        })
    } else{ 
      this.submitRes=[];
    }
  }
  vindetailsApi1(value: any) {
    if (this.componentId == "") {
      this.uid = ""
      this.id = ""
    }
    const req =
    {
      "requestType": this.type,
      "languageCode": this.language,
      "countryCode": this.country,
      "symptoms": this.symptomList,
      "vehicleModel": this.invinnumber,
      "procuId": this.uid,
      "componentId": this.id,
      "username": this.username
    }
    if (this.type && this.language && this.country && this.symptomList &&
      this.invinnumber && this.uid && this.id) {
      this.service.insertTargetEngineTestDetails(req).subscribe(
        (data) => {
          this.submitRes = data;
          this.isShow = true;
          this.iserr = false;
          if (this.submitRes.response == "candidates not found") {
            this.isShow = false;
            this.iserr = true;
          }
        })
    }else{
      this.submitRes=[];
    }
  }
  getVin() {
    this.service.getTargetEngineTestDetailsApi(this.invinnumber, this.country, this.language).subscribe((data) => {
      this.getApiRes = data;
      this.vehicleModel = this.getApiRes.vehicleModelXml;
    })
  }
  updateList() {
    if (this.componentId) {
      this.showSuggest = true

      for (let c of this.TEPostRepairDetails) {
        if (this.componentId == c.description) {
          this.id = c.id
          this.uid = c.gnumber
        }
      }
    }
    else {
      this.showSuggest = false
    }
  }

  onSelectAllComponent(setAllCompname: any) {
    this.componentId = setAllCompname;

    for (let c of this.TEPostRepairDetails) {
      if (this.componentId == c.description) {
        this.id = c.id
        this.uid = c.gnumber
      }
    }




  }

}
